import { Card, Descriptions, Space, Table } from 'antd';
import { useContext } from 'react';
import CreateDrawer from '../../../components/create';
import Loading from '../../../components/loader';
import { PageContext } from '../../../lib/context';
import RatesForm from './form';
// import MeterForm from './form';
const MeterView = () => {
  const { columns, rates, meters, rateColumns, _submitHandler, rate_loading } =
    useContext(PageContext);

  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Rates</p>
      </div>

      {/* button */}
      <Space>
        <CreateDrawer
          title="Create Rate"
          _submitHandler={_submitHandler}
          addForm={true}
        >
          <RatesForm />
        </CreateDrawer>
      </Space>


      <div className="flex flex-row">
        <Card
          style={{
            borderRadius: 20,
            flexDirection: 'row',
            height: 300,
            width: 600,
            marginRight: 20,
            display: 'none',
          }}
        >
          <div className="flex flex-row">
            <div className="mr-20"></div>
            <div style={{ height: 230, width: 230 }}>
              {/* <Bar height={300} width={300} data={data} type="line" /> */}
            </div>
          </div>
        </Card>
      </div>
      <div className="flex flex-row mt-5">
        <div className="w-full mr-3">
          {rate_loading ? (
            <div className="mt-32">
              <Loading show={rate_loading} />
            </div>
          ) : (
            <Table
              dataSource={rates}
              columns={columns}
              expandable={{
                expandedRowRender: record => (
                  <div className="p5">
                    <Table columns={rateColumns} dataSource={record.lists} />
                  </div>
                ),
              }}
            />)}
        </div>
      </div>
    </div>
  );
};

export default MeterView;
